import { TypeKeyValue } from "../interfaces";

export const TypeTransporte: TypeKeyValue[] = [
    { id: '0', name: '0 - Não Informado' },
    { id: '1', name: '1 - ETC' },
    { id: '2', name: '2 - TAC' },
    { id: '3', name: '3 - CTC' },
];

export const TypeModal: TypeKeyValue[] = [
    { id: '1', name: '1 - Rodoviário' },
    { id: '2', name: '2 - Aéreo' },
    { id: '3', name: '3 - Aquaviário' },
    { id: '4', name: '4 - Ferroviário' },
];

export const TypeEmitente: TypeKeyValue[] = [
    { id: '1', name: '1 - Prestador de Serviço de Transporte' },
    { id: '2', name: '2 - Transportador de Carga Própria' },
];

export const TypeEmbarcacao: TypeKeyValue[] = [
    { id: '01', name: '01 - Graneleiro' },
    { id: '02', name: '02 - Petroleiro' },
    { id: '03', name: '03 - Porta-contêineres' },
    { id: '04', name: '04 - Cargueiro Geral' },
    { id: '05', name: '05 - Transatlântico ' },
    { id: '06', name: '06 - Ferry' },
    { id: '07', name: '07 - Lancha de Passageiros' },
    { id: '08', name: '08 - Barco de Pesca Artesanal' },
    { id: '09', name: '09 - Traineira' },
    { id: '10', name: '10 - Barco de Pesca Industrial' },
    { id: '11', name: '11 - Rebocador' },
    { id: '12', name: '12 - Empurrador' },
    { id: '13', name: '13 - Navio de Apoio Offshore' },
    { id: '14', name: '14 - Fragata' },
    { id: '15', name: '15 - Corveta' },
    { id: '16', name: '16 - Submarino' },
    { id: '17', name: '17 - Iate' },
    { id: '18', name: '18 - Lancha' },
    { id: '19', name: '19 - Veleiro' },
];

export const TypeNavegacao: TypeKeyValue[] = [
    { id: '9', name: '9 - Não Informado' },
    { id: '0', name: '0 - Interior' },
    { id: '1', name: '1 - Cabotagem' },
];

export const TypeUnidadesCargaVazia: TypeKeyValue[] = [
    { id: '1', name: '1 - Container' },
    { id: '2', name: '2 - ULD' },
    { id: '3', name: '3 - Pallet' },
    { id: '4', name: '4 - Outros' },
];

export const TypeUnidadesTransporteVazia: TypeKeyValue[] = [
    { id: '1', name: '1 - Rodoviario Tração tipo Caminhão' },
    { id: '2', name: '2 - Roboque tipo carreta' },
];

export const TypeCategCombVeic: TypeKeyValue[] = [
    { id: '', name: 'Não informado' },
    { id: '02', name: '02 Veículo Comercial 2 eixos' },
    { id: '04', name: '04 Veículo Comercial 3 eixos' },
    { id: '06', name: '06 Veículo Comercial 4 eixos' },
    { id: '07', name: '07 Veículo Comercial 5 eixos' },
    { id: '08', name: '08 Veículo Comercial 6 eixos' },
    { id: '10', name: '10 Veículo Comercial 7 eixos' },
    { id: '11', name: '11 Veículo Comercial 8 eixos' },
    { id: '12', name: '12 Veículo Comercial 9 eixos' },
    { id: '13', name: '13 Veículo Comercial 10 eixos' },
    { id: '14', name: '14 Veículo Comercial Acima de 10 eixos' }
];

export const TypeComponente: TypeKeyValue[] = [
    { id: '01', name: '01 - Vale Pedágio' },
    { id: '02', name: '02 - Impostos, taxas e contrituições' },
    { id: '03', name: '03 - Despesas (bancárias, meios de pagamentos, outras)' },
    { id: '99', name: '99 - Outros' },
]

export const TypeRespSeguro: TypeKeyValue[] = [
    { id: '1', name: '1 - Emitente do MDF-e' },
    { id: '2', name: '2 - Responsavel pela contratação(Contratante)' },
];

export const TypeUnidadeTransporte: TypeKeyValue[] = [
    { id: '1', name: 'Rodoviário Tração' },
    { id: '2', name: 'Rodoviário Reboque' },
    { id: '3', name: 'Navio' },
    { id: '4', name: 'Balsa' },
    { id: '5', name: 'Aeronave' },
    { id: '6', name: 'Vagão' },
    { id: '7', name: 'Outros' },
];

export const TypeCarroceriaVeiculo: TypeKeyValue[] = [
    { id: '0', name: '0 - Não Aplicável' },
    { id: '1', name: '1 - Aberta' },
    { id: '2', name: '2 - Fechada/Baú' },
    { id: '3', name: '3 - Granelera' },
    { id: '4', name: '4 - Porta Container' },
    { id: '5', name: '5 - Sider' },
];

export const TypeRodadoVeiculo: TypeKeyValue[] = [
    { id: '1', name: '1 - Truck' },
    { id: '2', name: '2 - Toco' },
    { id: '3', name: '3 - Cavalo Mecanico' },
    { id: '4', name: '4 - VAN' },
    { id: '5', name: '5 - Utilitario' },
    { id: '6', name: '6 - Outros' },
];

export const TypeProprietarioVeiculo: TypeKeyValue[] = [
    { id: '', name: 'Selecione' },
    { id: '0', name: '0 - TAC Agregado' },
    { id: '1', name: '1 - TAC Independente' },
    { id: '2', name: '2 - Outros' },
];

export const TypeCargaProdutoPredominante: TypeKeyValue[] = [
    { id: '0', name: 'Selecione' },
    { id: '01', name: '01-Granel sólido' },
    { id: '02', name: '02-Granel líquido' },
    { id: '03', name: '03-Frigorificada' },
    { id: '04', name: '04-Conteinerizada' },
    { id: '05', name: '05-Carga geral' },
    { id: '06', name: '06-Neogranel' },
    { id: '07', name: '07-Perigosa (granel sólido)' },
    { id: '08', name: '08-Perigosa (granel líquido)' },
    { id: '09', name: '09-Perigosa (carga frigorificada)' },
    { id: '10', name: '10-Perigosa (conteinerizada)' },
    { id: '11', name: '11-Perigosa (carga geral)' },
];